// Which brand the current domain belongs to.
//
// One admin build serves both companies, split by hostname — the same rule
// AdminPanel uses to seed its company switcher. Keeping the choice here means the
// login, loading and access-denied screens cannot drift into showing one brand's
// mark to the other's staff.

export function isMobilistanHost() {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.includes('mobilistan');
}

/** Logo for the current domain. */
export function brandLogo() {
  return isMobilistanHost() ? '/mobilistan-logo.png' : '/logo.png';
}

/** Company name for the current domain, for alt text and headings. */
export function brandName() {
  return isMobilistanHost() ? 'Mobilistan' : 'Al Sami Electronics';
}

// Staff screens (login, first-time password) always carry Mobilistan's mark — the office
// works for Mobilistan whichever domain the panel is opened on (owner, 18 Oct 2026). The
// The loading screen carries Mobilistan's mark too (owner, 20 Oct 2026).
export const STAFF_LOGO = '/mobilistan-logo.png';
export const STAFF_NAME = 'Mobilistan';
